import ElementsContainer from "../../../Components/Bonus/Elements";

const Elements = () => {
  return <ElementsContainer />;
};

export default Elements;
